module.exports = __webpack_public_path__ + "static/user-thumbnail-3-b9e1cb3cffabb416912e62e5d49755af.png";